<template>
    <div>
        <Progress :active="progressActive"/>

        <div class="popup main_01">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p>유효하지 않는 기획전입니다.</p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" @click="$router.replace('/main')">확 인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>
        
        <div class="popup main_02">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p>선물 생성에 오류가 발생했습니다.</p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" @click="$router.replace('/main')">확 인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>
    </div>
</template>

<script>
import Progress from '@/components/Progress1'
import {api} from '@/api/index.js'

export default { 
    data() {
        return {
            progressActive : false,
            eventType : {}
        }
    },
    async mounted() {
        this.progressActive = true;

    },
    async created() {
        let disp_ctg_no = this.$route.query.disp_ctg_no;
        let params = {shop_disp_type_cd_list : ["10", "90"], disp_ctg_no:disp_ctg_no};

        await api.postAsync('/event/initMain.do',params)
            .then(data=>{
                console.log(data.eventTypes);
                if(data.eventTypes.length === 0) {
                    $('.main_01').addClass('active');
                }
                else {
                    this.eventType = data.eventTypes[0];
                    this.eventType.event_nm = data.eventTypes[0].disp_ctg_nm;
                    this.eventType.event_divi_cd = data.eventTypes[0].disp_ctg_no;
                    this.eventType.init_batch_dlv_yn = 'N';

                    api.postAsync('/event/addEvent.do', this.eventType)
                        .then(data=>{
                            
                            let url = `/eventDtl/${data.event_no}/recoSetting?init_batch_dlv_yn=${this.eventType.init_batch_dlv_yn}`;

                            if (this.eventType.searchTerm != undefined && this.eventType.searchTerm != "") {
                                url = url + `&searchTerm=${this.eventType.searchTerm}`
                            }

                            this.$router.replace(url);
                        })
                        .catch(error=>{
                            console.log(error);
                            $('.main_02').addClass('active');
                        });

                }
                
            });
    },
    components: {Progress}
}
</script>


<!-- <template>
    <div id="wrap">
        <MainHeader title="행사 추가" cart="N"/>
        <section class="event_select_add"> 
            <h3>행사 정보를 입력해 주세요.</h3>
            <div class="event_select_add_form">
                <input type="date" id="inputDate" ref="inputDate" placeholder="연도-월-일" v-model="addEventInfo.event_date" pattern="\d{4}-\d{2}-\d{2}" required style="opacity:0; height:0; width:0;">
                <input type="time" ref="inputTime" v-model="addEventInfo.event_time" style="opacity:0; height:0; width:0;">
                <ul class="inquiry">
                    <li>
                        <label>행사유형</label>
                        <div class="event_select_radio icon">
                            <div v-for="type in eventTypes" :key="type.comm_dtl_cd" class="radio">
                                <input type="radio" v-model="addEventInfo.event_divi_cd" :value="type.comm_dtl_cd" :id="`radio${type.comm_dtl_cd}`" name="event_type">
                                <label :for="`radio${type.comm_dtl_cd}`"><i :class="getIcon(type)"></i>{{type.show_nm}}</label>
                            </div>
                        </div>                   
                        
                    </li>
                    <li>
                        <label>행사명</label>
                        <input type="text" placeholder="이름 (장소)" v-model="addEventInfo.event_nm" ref="vendName" maxlength="50">
                    </li>
                    <li class="clearfix">
                        <label>행사일정</label>
                        <input type="button" v-model="addEventInfo.event_date" @click="openCal" style="line-height:0; text-align:left">
                        <input class="float-right" type="button" placeholder="-- --:--" v-model="addEventInfo.event_time" style="text-align:left;margin-right:4px;line-height:0;" @click="openTime" hidden>
                        
                    </li>
                </ul> 

                <ul class="inquiry" v-if="eventList != undefined && eventList.length > 0">
                    <li>
                        <div class="input-form-checkbox">
                            <input type="checkbox" id="rul-agree" v-model="addEventInfo.autoAddRecvr" true-value="Y" false-value="N">
                            <label for="rul-agree"><i class="xi-check-min" ></i>기존 행사에 설정된 수신자들을 자동으로 추가합니다.</label>
                        </div>
                    </li>
                    <li>
                        <label>행사명</label>
                        <div class="select_form">
                            
                            <select v-model="addEventInfo.added_event_no" @change="test">
                                <option :value="undefined">행사 선택하기</option>
                                <option v-for="event in eventList" :key="event.event_no" :value="event.event_no">{{event.event_nm}}</option>
                            </select>
                        </div>
                    </li>
                </ul> 
                <button class="btn_large" @click="addEvent()">추 가</button>
            </div>
        </section>

        
        <div class="popup add_event_alert_01">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p>{{alertMsg}}</p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" onclick="modal('add_event_alert_01')">확 인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>
        
        <div class="popup add_event_alert_02">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p>{{alertMsg}}</p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" @click="$router.replace(alertData1)">확 인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>
        <Progress :active="progressActive"/>
    </div>
</template>

<script>
import {api} from '../api/index.js'
import MainHeader from '@/components/MainHeader.vue'
import Progress from '@/components/Progress1'

export default {
    name: 'AddEvent',
    data() {
        return {
            alertMsg: '',
            alertData1: '',

            eventList: undefined,
            eventTypes: [],
            addEventInfo: {
                event_divi_cd: '',
                event_nm:'',
                event_date:'행사 시작일을 입력해 주세요.',
                event_time:'00:00',
                event_start_dtime: '',
                autoAddRecvr: 'N',
            },
            
            min:'',

            progressActive: false,
        }
    },
    methods: {
        openTime() {
            this.$refs.inputTime.focus();
            this.$refs.inputTime.click();
        },
        test() {
            console.log(this.addEventInfo.added_event_no)
            if(this.addEventInfo.added_event_no === undefined) {
                this.addEventInfo.autoAddRecvr = 'N';
            }
            else {
                this.addEventInfo.autoAddRecvr = 'Y';
            }
        },
        getIcon(type) {
            const cd = type.comm_dtl_cd;
            if (cd === '01') {
                return 'icon_celebrate';
            }
            else if (cd === '02') {
                return 'icon_thanks';
            }
            else if (cd === '03') {
                return 'icon_encourage';
            }
            else if (cd === '04') {
                return 'icon_dogday';
            }
            else if (cd === '05') {
                return 'icon_return';
            }
            
            
        },
        openCal() {
            this.$refs.inputDate.focus(); //for ios
            this.$refs.inputDate.click(); //for and
        },
        addEvent() {
            if(this.addEventInfo.event_nm === "") {
                this.alertMsg = "행사 이름을 입력해 주세요.";
                $('.add_event_alert_01').addClass('active');
                return;
            }

            if(this.addEventInfo.event_date === "행사 시작일을 입력해 주세요.") {
                this.alertMsg = "행사 시작일을 입력해 주세요.";
                $('.add_event_alert_01').addClass('active');
                return;
            }

            if(this.addEventInfo.event_time === "") {
                this.alertMsg = "행사 시간을 입력해 주세요."
                $('.add_event_alert_01').addClass('active');
                return;
            }

            if(this.addEventInfo.autoAddRecvr === 'Y') {
                if(this.addEventInfo.added_event_no === null || this.addEventInfo.added_event_no === undefined) {
                    alert('행사를 선택해 주세요.')
                    return;
                }
            }
            this.addEventInfo.event_start_dtime = this.addEventInfo.event_date+' '+this.addEventInfo.event_time;
            this.progressActive = true;
            api.postAsync('/event/addEvent.do', this.addEventInfo)
                .then(data=>{
                    this.progressActive = false;
                    if(!alert('새 행사가 생성되었습니다')) {
                        if(this.addEventInfo.autoAddRecvr === 'Y') {
                            this.$router.replace(`/eventDtl/${data.event_no}/selectRecvr`);
                        }
                        else {
                            this.$router.replace(`/eventDtl/${data.event_no}/recoSetting`);
                        }
                    }
                });
            
        }

    },
    async created() {
        await api.postAsync('/event/initAddEvent.do')
            .then(data=>{
                console.log(data)
                this.eventTypes = data.eventTypes;
                this.addEventInfo.event_divi_cd = data.eventTypes[0].comm_dtl_cd;
                this.eventList = data.eventList;

                let today = new Date();
                this.min =  today.getFullYear() + '-'
                        +(today.getMonth()+1 < 10 ? '0'+(today.getMonth()+1) : today.getMonth()+1) + '-'
                        +(today.getDate() < 10 ? '0'+today.getDate() : today.getDate());
            });

        
    },
    components: {MainHeader, Progress}
    
}
</script> -->
